export default __webpack_public_path__ + "static/media/financiamento-credito.0acbe5f3.svg";